export class TotalizadorResumo {
    public id: number;
    public categoria: string;
    public valorMarca = 0.; 
 }